/* eslint-disable */
/* eslint-disable no-unused-vars */

import React, { useEffect, useState } from 'react';
import {
  CommonDropdown,
  RegularButton,
  CommonInput,
  ICommonDropdownOption,
  AlertAdapter,
  DataTableCellDeleteButton,
  DataTableCellEditButton,
} from 'pg-ui-library';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import ChatFaqService from 'src/services/chat-bot-faq.service';

import { FiChevronDown, FiChevronUp, FiSearch, FiX, FiPlus } from 'react-icons/fi';

import { FaqModal } from './faq-modal-add-update';
import ConfirmationModal from './confirmation-modal';
import {
  FAQContainer,
  FAQHeader,
  FAQTitle,
  FAQSubtitle,
  SearchContainer,
  SearchBox,
  SearchInput,
  SearchIcon,
  ClearSearchButton,
  CategoryFilter,
  CategoryButton,
  FAQContent,
  FAQCategoryWrapper,
  FAQCategoryTitle,
  FAQItem,
  FAQQuestion,
  FAQAnswer,
  FAQIcon,
  RightHeader,
  PageTitle,
  ScreenHeader,
  ModalBackdrop,
  ModalContainer,
  FAQActions,
} from './styles';

interface FAQItemType {
  id: string;
  question: string;
  answer: string;
  type: string;
  category: string;
  redirectUrl?: string;
  reviewed?: boolean;
  createdAt?: string;
}

const faqTypes = ['all', 'benefits', 'tax forms', 'profile', 'general'];

const categoryList = ['all', 'general', 'account', 'billing', 'technical'];

export const Faq: React.FC = () => {
  const [faqItems, setFaqItems] = useState<FAQItemType[]>([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [activeCategory, setActiveCategory] = useState('');
  const [activeItemId, setActiveItemId] = useState<string | null>(null);
  const [isFaqModalOpen, setIsFaqModalOpen] = useState(false);
  const [faqToEdit, setFaqToEdit] = useState<FAQItemType | null>(null);
  const [searchTerm, setsearchTerm] = useState('');
  const [faqToDelete, setFaqToDelete] = useState<FAQItemType | null>(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);

  // The item selected for deletion

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const companyId = '';

  const fetchFaqs = async () => {
    try {
      const data = await ChatFaqService.getAllFaqs({ type: activeCategory || '' });
      setFaqItems(Array.isArray(data) ? data : []);
    } catch (error) {
      AlertAdapter('Failed to load FAQs', 'error');
    }
  };

  const { isFetching, data, refetch } = useQuery(['faq'], async () => {
    const result = await ChatFaqService.getAllFaqs({
      companyId,
    });
    return result;
  });

  useEffect(() => {
    if (Array.isArray(data)) {
      setFaqItems(data);
    }
  }, [data]);

  useEffect(() => {
    refetch();
  }, [page, limit, status, searchTerm, refetch]);

  const handleEdit = (faqItem: any) => {
    setFaqToEdit(faqItem);
    setIsFaqModalOpen(true);
  };

  const handleConfirm = async () => {
    if (!faqToDelete) return;
    try {
      await ChatFaqService.deleteFaq(faqToDelete.id);
      AlertAdapter('FAQ deleted successfully', 'success');
      refetch();
    } catch (error) {
      AlertAdapter('Failed to delete FAQ', 'error');
    } finally {
      setIsModalOpen(false);
      setFaqToDelete(null);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setFaqToDelete(null);
  };

  const handleDelete = (faqId: string) => {
    const toDelete = faqItems.find(faq => faq.id === faqId);
    if (toDelete) {
      setFaqToDelete(toDelete);
      setIsModalOpen(true);
    }
  };

  const toggleActiveItem = (id: string) => {
    if (activeItemId === id) {
      setActiveItemId(null);
    } else {
      setActiveItemId(id);
    }
  };

  const toggleItem = (id: string) => {
    setActiveItemId(prevId => (prevId === id ? null : id));
  };

  // const filteredFaqs = faqItems.filter(item =>
  //   item.question.toLowerCase().includes(searchQuery.toLowerCase())
  // );

  const filteredFaqs = faqItems.filter(item => {
    // Filter by category
    const categoryMatch = activeCategory === 'all' || item.category === activeCategory;

    // Filter by search query
    const searchMatch = item.question.toLowerCase().includes(searchQuery.toLowerCase());

    return categoryMatch && searchMatch;
  });

  const confirmDelete = async () => {
    if (!faqToDelete) return;

    try {
      console.log('faqToDelete.id', faqToDelete.id);
      await ChatFaqService.deleteFaq(faqToDelete.id);
      AlertAdapter('FAQ deleted successfully', 'success');
      refetch();
    } catch (error) {
      AlertAdapter('Failed to delete FAQ', 'error');
    } finally {
      setIsDeleteModalOpen(false);
      setFaqToDelete(null);
    }
  };

  return (
    <FAQContainer>
      <ConfirmationModal
        isOpen={isModalOpen}
        message="Please confirm if you want to remove this FAQ."
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />

      {isDeleteModalOpen && (
        <ModalBackdrop>
          <ModalContainer>
            <h3>Confirm Deletion</h3>
            <p>Are you sure you want to delete this FAQ?</p>
            <div className="modal-actions">
              <RegularButton onClick={confirmDelete}>Yes, Delete</RegularButton>
              <RegularButton
                onClick={() => {
                  setIsDeleteModalOpen(false);
                  setFaqToDelete(null);
                }}
                style={{
                  backgroundColor: '#ccc',
                  color: '#000',
                  border: '1px solid #999',
                }}
              >
                Cancel
              </RegularButton>
            </div>
          </ModalContainer>
        </ModalBackdrop>
      )}

      <FaqModal isOpen={isFaqModalOpen} setIsOpen={setIsFaqModalOpen} faqData={faqToEdit} refetch={refetch} />
      <ScreenHeader>
        <PageTitle>Frequently Asked Questions FAQ</PageTitle>

        <RightHeader style={{ display: 'flex', alignItems: 'center' }}>
          <CommonInput
            id="searchQuery"
            name="searchQuery"
            placeholder="Search..."
            value={searchTerm}
            onChange={event => {
              let newValue = event.target.value;
              newValue = newValue.replace(/[',.]/g, '');
              setsearchTerm(newValue);
            }}
            style={{
              width: '200px',
              marginRight: '10px',
              backgroundColor: 'white',
              color: 'black',
              border: '1px solid #ccc',
              borderRadius: '4px',
              padding: '5px',
            }}
            label=""
          />
          <RegularButton
            onClick={() => {
              setFaqToEdit(null); // Reset
              setIsFaqModalOpen(true);
            }}
          >
            Create New
          </RegularButton>
        </RightHeader>
      </ScreenHeader>

      <CategoryFilter>
        {faqTypes.map(type => (
          <CategoryButton key={type} active={activeCategory === type} onClick={() => setActiveCategory(type)}>
            {type.toUpperCase()}
          </CategoryButton>
        ))}
      </CategoryFilter>

      <FAQContent>
        {filteredFaqs.length === 0 && <p>No FAQs found.</p>}

        {filteredFaqs.map(item => {
          const isActive = activeItemId === item.id;

          return (
            <FAQItem key={item.id} className={isActive ? 'active' : ''}>
              <FAQQuestion onClick={() => toggleActiveItem(item.id)}>
                <h3>{item.question}</h3>

                <FAQActions>
                  <DataTableCellEditButton
                    onClick={e => {
                      e.stopPropagation();
                      handleEdit(item);
                    }}
                  />
                  <DataTableCellDeleteButton
                    onClick={e => {
                      e.stopPropagation();
                      handleDelete(item.id);
                    }}
                  />
                  <FAQIcon>{activeItemId === item.id ? <FiX /> : <FiPlus />}</FAQIcon>
                </FAQActions>
              </FAQQuestion>

              <FAQAnswer style={{ display: isActive ? 'block' : 'none' }}>
                <p>{item.answer}</p>
              </FAQAnswer>
            </FAQItem>
          );
        })}
      </FAQContent>
    </FAQContainer>
  );
};

export default Faq;
